import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursForWho() {
  const forWho = ['Femei și bărbați care simt blocaje financiare și nu înțeleg de ce banii vin greu, deși muncesc mult.', 'Persoane care câștigă bani dar nu reușesc să îi păstreze, având mereu un sentiment de neajuns.', 'Antreprenori sau freelanceri care simt că ceva îi blochează în creșterea financiară.'];
  const notForWho = ['Cei care caută îmbogățire rapidă sau un curs de investiții și trading.', 'Persoane sceptice și complet închise la ideea că emoțiile influențează banii.', 'Cei care vor doar tehnici financiare concrete, fără să lucreze cu interiorul lor.'];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-714">
      <div className="max-w-6xl mx-auto px-6" data-id="element-715">
        <SectionHeading title="Pentru cine este cursul Magnet pentru Bani" data-id="element-716" />

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-717">
          {/* Este pentru */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 border border-green-100 rounded-3xl p-8 lg:p-10" data-id="element-718">
            <div className="flex items-center gap-4 mb-8" data-id="element-719">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-720">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-721" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-722">
                Este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-723">
              {forWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-724">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-725" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-726">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* NU este pentru */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50/50 border border-red-100 rounded-3xl p-8 lg:p-10" data-id="element-727">
            <div className="flex items-center gap-4 mb-8" data-id="element-728">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-729">
                <AlertCircle className="w-6 h-6 text-red-600" data-id="element-730" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-731">
                NU este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-732">
              {notForWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-733">
                  <AlertCircle className="w-5 h-5 text-red-400 mt-1 flex-shrink-0" data-id="element-734" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-735">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-736">
          <CTAButton data-id="element-737" />
        </motion.div>
      </div>
    </section>;
}